module.exports = __webpack_public_path__ + "static/media/new-account.68cfabb1.svg";